import { markDone } from './state'

const newMovieClickHandlers = new WeakMap()
const newMovieHoverHandlers = new WeakMap()

function getNewMovieTarget(element) {
  if (!element) return null
  return element.querySelector('button, a') || element
}

function openNewMovieForm(event) {
  if (event && event.preventDefault) {
    event.preventDefault()
  }

  markDone('movies-list')
  sessionStorage.setItem('onboarding_next', 'movie-form')
  window.location.href = '/movies/form/new'
}

function applyNewMovieHoverStyle(target) {
  const el = target
  el.style.transition = 'background-color 0.2s ease, box-shadow 0.2s ease'
  el.style.backgroundColor = 'rgba(115, 103, 240, 0.12)'
  el.style.boxShadow = 'inset 0 0 0 1px rgba(115, 103, 240, 0.35)'
  el.style.borderRadius = '6px'
}

function clearNewMovieHoverStyle(target) {
  const el = target
  el.style.backgroundColor = ''
  el.style.boxShadow = ''
  el.style.borderRadius = ''
}

// eslint-disable-next-line import/prefer-default-export
export const movieSteps = [
  {
    element: '[data-tour="new-movie-btn"]',
    disableActiveInteraction: false,
    onHighlighted: element => {
      const clickTarget = getNewMovieTarget(element)
      if (!clickTarget) return

      newMovieClickHandlers.set(clickTarget, openNewMovieForm)
      clickTarget.addEventListener('click', openNewMovieForm)

      const mouseEnterHandler = () => applyNewMovieHoverStyle(clickTarget)
      const mouseLeaveHandler = () => clearNewMovieHoverStyle(clickTarget)
      newMovieHoverHandlers.set(clickTarget, {
        mouseEnterHandler,
        mouseLeaveHandler,
      })
      clickTarget.addEventListener('mouseenter', mouseEnterHandler)
      clickTarget.addEventListener('mouseleave', mouseLeaveHandler)
    },
    onDeselected: element => {
      const clickTarget = getNewMovieTarget(element)
      if (!clickTarget || !newMovieClickHandlers.has(clickTarget)) return

      clickTarget.removeEventListener('click', newMovieClickHandlers.get(clickTarget))
      newMovieClickHandlers.delete(clickTarget)

      if (newMovieHoverHandlers.has(clickTarget)) {
        const { mouseEnterHandler, mouseLeaveHandler } = newMovieHoverHandlers.get(clickTarget)
        clickTarget.removeEventListener('mouseenter', mouseEnterHandler)
        clickTarget.removeEventListener('mouseleave', mouseLeaveHandler)
        newMovieHoverHandlers.delete(clickTarget)
      }
      clearNewMovieHoverStyle(clickTarget)
    },
    popover: {
      title: 'Create Movie',
      description: 'Click this button to open the new movie form.',
      position: 'bottom',
      showButtons: ['previous'],
    },
  },
]
